'use strict';

class RcmFindTeacher {
    constructor() {}

    // Main method
    init() {
        this.data = [];
        this.dataProfile = null;

        this.resultsPaged = [{ hits: {}, count: 0 }];
        this.mapPageSize = 20;
        this.mapCurrentPage = 0;
        this.mapPageGroup = [0, 3];

        // Context
        this.window = $(window);
        this.document = $(document);

        // Context DOM
        this.htmlAndBody = $('html, body');
        this.html = $('html');
        this.body = $('body');
        this.header = $('header');
        this.elForm = $('#fatv2-form');

        // If form element exists
        if (this.elForm.length > 0) {
            this.facetNames = ['disciplines', 'agesTaught', 'languages', 'teachingLocation', 'rcmCredentials'];

            this.facetNamesTranslations = {
                disciplines: 'Instrument/Discipline',
                agesTaught: 'Age Group',
                languages: 'Language',
                teachingLocation: 'Lesson Location',
                rcmCredentials: 'Credentials',
            }

            this.addRootClasses();

            this.loader = new RcmFatLoader(this);
            this.modules = new RcmFatModules(this);
            this.browser = new RcmFatBrowser(this);

            this.form = new RcmFatForm(this);
            this.algolia = new RcmFatAlgolia(this);
            this.google = new RcmFatGoogle(this);

            this.resultsList = new RcmFatResultsList(this);
            this.resultsFilters = new RcmFatResultsFilters(this);
            this.resultsMap = new RcmFatResultsMap(this);
            this.profile = new RcmFatProfile(this);
            this.profileForm = new RcmFatProfileForm(this);

            this.callbacks = new RcmFatCallbacks(this);
            this.events = new RcmFatEvents(this);
            this.contactEvents = new RcmFatContactEvents(this);
        }
    }

    // Add root (html and body) classes
    addRootClasses() {
        this.html.addClass('fatv2-html');
        this.body.addClass('fatv2-body');

        if (navigator.userAgent.indexOf('Windows')) {
            this.html.addClass('fatv2-os-windows');
        }
    }

    // Get query string parameter
    _helperGetUrlParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }

        name = name.replace(/[\[\]]/g, "\\$&");

        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2]); // decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // Get teacher unique ID
    _helperGetTeacherUniqueId(objectID, lat, lon) {
        return `${objectID}_${this._helperGetLatLngAttr(lat, lon)}`;
    }

    // Get latitude and longitude to be used as HTML attribute
    _helperGetLatLngAttr(lat, lon) {
        lat = ('' + lat).replace(/[\.-]+/g, '');
        lon = ('' + lon).replace(/[\.-]+/g, '');
        return `${lat}-${lon}`;
    }

    // Translate distance
    _helperTranslateDistance(distanceInMeters) {
        var distance = '';
        var unit = 'KM';
        var region = this.google.autocomplete.get('place');

        region = region.address_components.filter(function (component) {
            return component.types.includes('country');
        });

        region = region[0].short_name.toLowerCase();

        if ('us' === region) {
            // Use Imperial (miles)
            distance = (distanceInMeters * 0.00062137).toFixed(2);
            unit = 'MI';
        } else {
            // Convert to KM
            distance = (distanceInMeters / 1000).toFixed(2);
        }

        return {
            'distance': distance,
            'unit': unit
        };
    }

    // Get label translation
    _helperGetFacetLabelTranslation(label) {
        return this.facetNamesTranslations[label];
    }

    // Get name initials
    _helperGetNameInitials(data) {
        var firstLetter = $.trim(data.firstName).replace(/^(.{1}).+$/gi, '$1').toUpperCase();
        var lastLetter = $.trim(data.lastName).replace(/.*(^| )([^ ]{1})[^ ]+$/gi, '$2').toUpperCase();
        var initials = firstLetter + lastLetter;
        return initials;
    }

    // Get Drupal env
    _helperGetDrupalEnv() {
        var env = 'prod';

        if (document.location.host == 'kentico-stg.rcmusic.com' || document.location.host == 'localhost:44308') {
            env = 'dev';
        }

        return env;
    }

    // Get Drupal base URL
    _helperGetDrupalBaseUrl() {
        var baseUrl = 'https://acquia-drupal-registration-service.rcmusic.com';

        if (this._helperGetDrupalEnv() == 'dev') {
            baseUrl = 'https://kentico-stg.rcmusic.com';
        }

        return baseUrl;
    }

    // Log Kentico Marketing Contacts Activities
    _helperLogActivity(_activityType, _activityTitle, _activityUrl = '') {

        if (!_activityType || !_activityTitle) {
            return;
        }

        const _activityData = {
            activityType: _activityType,
            activityTitle: _activityTitle,
            activityUrl: _activityUrl
        }

        // Send interaction information to kentico
        $.ajax({
            type: 'POST',
            url: '/RCM/API/MarketingContacts.asmx/LogActivity',
            data: JSON.stringify(_activityData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',

            success: function (responseData, textStatus, jqXHR) {
                responseData = JSON.parse(responseData.d);

                // Success
                if (responseData.Status == 'ERROR' && responseData.ErrorCode && responseData.ErrorCode != '') {
                    console.info(responseData.Status);
                    console.info(textStatus);
                    console.info(jqXHR);
                } 

            },

            error: function (responseData, textStatus, errorThrown) {
                console.info(responseData.Status);
                console.info(textStatus);
                console.info(errorThrown);
            }
        });


    }
}

TPS.RcmFindTeacher = new RcmFindTeacher();
